import PropTypes from "prop-types";

const InputText = (props) => {
  return (
    <input
      className={`w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-90 px-2 md:px-3 py-1 rounded-lg placeholder-gray-600 placeholder-opacity-50 focus:outline-none focus:bg-opacity-30 border border-primary border-opacity-0 focus:border-opacity-100 ${props.className}`}
      type={props.type || "text"}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      autoComplete={props.autoComplete}
      max={props.max}
      min={props.min}
    />
  );
};

InputText.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputText;
